import { requestStatus } from "../../../constants";

export const compareRequestStatus = (a: string, b: string): boolean => {
  if (a === b) return true;
  if (
    [requestStatus.submitted, requestStatus.preApproved].includes(a) &&
    [requestStatus.submitted, requestStatus.preApproved].includes(b)
  )
    return true;
  if (["InProgress", "c"].includes(a) && ["InProgress", "c"].includes(b))
    return true;
  return false;
};
